import { useTranslation } from "react-i18next";

import OrdersView from "../../../orders/views/OrdersView/OrdersView";

export default function SuperAdminCloudSalesOrdersView() {
	const { t } = useTranslation();

	return <OrdersView header={t("cloudSalesOrders", "Cloud sales orders")} expense={false} cloud showFirstParty />;
}
